import type { ImageType, PaginationMeta } from '@eliadmin/core/src/api/api-types';
import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { getBlogExcerpt } from '@eliadmin/core/src/utils/blog-utils';

/** What an article card shows – the full article HTML never goes into props or the query cache. */
export type PostCardData = {
  id: number;
  slug: string;
  name: string;
  excerpt: string;
  image: ImageType | null;
  createdAt: string;
  /** The first category (badge on the photo, label in the meta row). */
  category: string | null;
};

/** One page of a card list, as the server seeds the grid and „Zobraziť viac článkov“ extends it. */
export type PostPage = { posts: PostCardData[]; page: number; lastPage: number };

/** Cards clamp the excerpt to two lines; the featured article shows more of it. */
export function toPostCard(post: Blog, excerptLength = 200): PostCardData {
  return {
    id: post.id,
    slug: post.slug,
    name: post.name,
    excerpt: getBlogExcerpt(post.content, excerptLength),
    image: post.image,
    createdAt: post.created_at,
    category: post.categories[0]?.name ?? null,
  };
}

export function toPostPage({ data, meta }: { data: Blog[]; meta: PaginationMeta }): PostPage {
  return {
    posts: data.map(post => toPostCard(post)),
    page: meta.current_page,
    lastPage: meta.last_page,
  };
}
